import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { Validation, ContractType, PersonType } from '../../models';
import { ErrorMessage, CssClass, Regex } from '../../constants';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class EmailValidationService {
  constructor(private gtmDataLayerUiService: GtmDatalayerUiService) {

  }

  emailValidSubject: Subject<Validation> = new Subject<Validation>();
  emailValid$ = this.emailValidSubject.asObservable();
  private error: Validation = new Validation();
  isInValid(contractType: ContractType): boolean {
    let validation = this.emailValidation(contractType)
    this.setError(validation);
    return validation.isInValid;
  }
  private emailValidation(contractType: ContractType): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    if (contractType.emailAddress == undefined || contractType.emailAddress == null || contractType.emailAddress == '' || !this.validateEmail(contractType.emailAddress)) {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.email)
    }
    return validation;
  }
  setError(error: Validation) {
    this.emailValidSubject.next(error);
  }
  validateEmail(email) {
    return Regex.email.test(email);
  }
}
